module.exports = __webpack_public_path__ + "img/ee-white.c9aa5ba3.png";